import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const NavBar = ({ className }) => {
    const navs = window.cccisd?.appDefs?.navs || [];
    const primaryNav = navs.find(nav => nav.handle === 'header');

    return (
        <Header
            containerClassName={className}
            wrapperClassName={style.wrapper}
            logoClassName={style.logo}
            showAlertAction={false}
            showHomeAction={false}
            primaryNavLinks={primaryNav?.nav || []}
            isDarkPrimaryNav
        />
    );
};

NavBar.defaultProps = {
    className: 'container',
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;
